export const INVEST_PAGES = [
  {
    slug: "investissements",
    fr: {
      eyebrow: "Investissements",
      title: "Une gestion d'investissement individuelle, un cadre garanti.",
      intro:
        "Nous gérons les fonds de chaque client individuellement, avec un soutien personnalisé à chaque investisseur — et un cadre de protection sur les placements immobiliers et financiers.",
      chips: ["Immobilier", "Indépendance", "Transparence", "Personnalisation", "Confidentialité"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "Une activité mesurable",
          items: [
            { value: "1 M €", label: "Ticket d'entrée minimum par mandat" },
            { value: "14", label: "Marchés immobiliers suivis" },
            { value: "4 % – 12 %", label: "Commission transparente" },
            { value: "3–7 ans", label: "Horizon d'investissement type" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Deux catégories, des marchés soigneusement sélectionnés",
          sub: "Notre activité se concentre sur deux classes complémentaires, déployées selon le potentiel et le cadre juridique de chaque marché.",
          items: [
            {
              title: "Immobilier",
              desc: "Acquisition, gestion et valorisation d'actifs immobiliers sur des marchés à fort potentiel.",
              tags: ["Suisse", "Belgique", "Italie", "Espagne", "Canada", "Mexique", "Panama", "Uruguay", "Thaïlande", "Vietnam", "Afrique du Sud"],
            },
            {
              title: "Start-ups & croissance",
              desc: "Financement et accompagnement de start-ups, du seed à la croissance, sur des écosystèmes innovants.",
              tags: ["États-Unis", "Canada", "Pays-Bas", "Belgique", "Japon", "Hong Kong", "Singapour"],
            },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Notre processus d'investissement",
          items: [
            { title: "Screening initial", desc: "Les responsables senior examinent chaque opportunité avant tout travail approfondi." },
            { title: "Analyse approfondie", desc: "Recherche documentée sur l'actif, la contrepartie, le marché et le cadre juridique." },
            { title: "Revue du comité", desc: "Le comité d'investissement évalue les rendements ajustés au risque." },
            { title: "Exécution", desc: "Mise en œuvre rapide, avec une transparence totale sur coûts et délais." },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Programme de prêt direct senior",
          sub: "Nous servons les entreprises du marché intermédiaire et les sociétés de capital-investissement, principalement des emprunteurs avec 5 à 40 M € d'EBITDA, en partenaire de financement durable.",
          items: [
            { title: "Capital flexible", desc: "Une taille de détention minimale qui permet des solutions de financement total." },
            { title: "Équipe expérimentée", desc: "Une expérience approfondie de la structuration, de la souscription et de la gestion d'investissements." },
            { title: "Partenaire fiable", desc: "Un soutien sur tout le cycle d'investissement : croissance organique, acquisitions, recapitalisations." },
            { title: "Position de prêteur principal", desc: "Voir les opportunités en premier, avec une diligence renforcée et un rôle actif dans la structuration." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Nos solutions de financement",
          sub: "Des structures adaptées à chaque étape de croissance, en approche Open Book : tous les coûts, frais et rendements visibles.",
          items: ["Facilités de crédit renouvelables", "Unitranche / Senior Stretch", "Prêts de second rang", "Capital junior / Mezzanine", "Solutions de finance crypto"],
        },
      ],
    },
    en: {
      eyebrow: "Investments",
      title: "Individual investment management, a protected framework.",
      intro:
        "We manage each client's funds individually, with personalised support for every investor — and a protective framework on real estate and financial placements.",
      chips: ["Real estate", "Independence", "Transparency", "Personalisation", "Confidentiality"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "A measurable activity",
          items: [
            { value: "€1M", label: "Minimum entry ticket per mandate" },
            { value: "14", label: "Real estate markets tracked" },
            { value: "4% – 12%", label: "Transparent commission" },
            { value: "3–7 yrs", label: "Typical investment horizon" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Two categories, carefully selected markets",
          sub: "Our activity concentrates on two complementary classes, deployed according to each market's potential and legal framework.",
          items: [
            {
              title: "Real estate",
              desc: "Acquisition, management and value creation across high-potential real estate markets.",
              tags: ["Switzerland", "Belgium", "Italy", "Spain", "Canada", "Mexico", "Panama", "Uruguay", "Thailand", "Vietnam", "South Africa"],
            },
            {
              title: "Start-ups & growth",
              desc: "Financing and support for start-ups, from seed to growth, in innovative ecosystems.",
              tags: ["United States", "Canada", "Netherlands", "Belgium", "Japan", "Hong Kong", "Singapore"],
            },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Our investment process",
          items: [
            { title: "Initial screening", desc: "Senior leads review every opportunity before any in-depth work begins." },
            { title: "Deep analysis", desc: "Documented research on the asset, the counterparty, the market and the legal framework." },
            { title: "Committee review", desc: "The investment committee assesses risk-adjusted returns." },
            { title: "Execution", desc: "Rapid implementation, with full transparency on costs and timelines." },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Senior direct lending programme",
          sub: "We serve mid-market companies and private equity firms, mainly borrowers with €5–40M EBITDA, as a durable financing partner.",
          items: [
            { title: "Flexible capital", desc: "A minimum hold size that enables full financing solutions." },
            { title: "Experienced team", desc: "Deep experience in structuring, underwriting and managing investments." },
            { title: "Reliable partner", desc: "Support across the full investment cycle: organic growth, acquisitions, recapitalisations." },
            { title: "Lead lender position", desc: "Seeing opportunities first, with enhanced diligence and an active structuring role." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Our financing solutions",
          sub: "Structures adapted to each growth stage, with an open-book approach: all costs, fees and returns visible.",
          items: ["Revolving credit facilities", "Unitranche / Senior stretch", "Second-lien loans", "Junior capital / Mezzanine", "Crypto financing solutions"],
        },
      ],
    },
    de: {
      eyebrow: "Investitionen",
      title: "Individuelles Investmentmanagement, ein geschützter Rahmen.",
      intro:
        "Wir verwalten die Gelder jedes Kunden individuell, mit persönlicher Betreuung für jeden Investor — und einem Schutzrahmen für Immobilien- und Finanzanlagen.",
      chips: ["Immobilien", "Unabhängigkeit", "Transparenz", "Personalisierung", "Vertraulichkeit"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "Eine messbare Tätigkeit",
          items: [
            { value: "1 Mio. €", label: "Mindest-Einstiegsticket pro Mandat" },
            { value: "14", label: "Beobachtete Immobilienmärkte" },
            { value: "4 % – 12 %", label: "Transparente Kommission" },
            { value: "3–7 Jahre", label: "Typischer Anlagehorizont" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Zwei Kategorien, sorgfältig ausgewählte Märkte",
          sub: "Unsere Tätigkeit konzentriert sich auf zwei komplementäre Klassen, eingesetzt je nach Potenzial und Rechtsrahmen jedes Marktes.",
          items: [
            {
              title: "Immobilien",
              desc: "Erwerb, Verwaltung und Wertschöpfung von Immobilienanlagen auf Märkten mit hohem Potenzial.",
              tags: ["Schweiz", "Belgien", "Italien", "Spanien", "Kanada", "Mexiko", "Panama", "Uruguay", "Thailand", "Vietnam", "Südafrika"],
            },
            {
              title: "Start-ups & Wachstum",
              desc: "Finanzierung und Begleitung von Start-ups, von Seed bis Wachstum, in innovativen Ökosystemen.",
              tags: ["USA", "Kanada", "Niederlande", "Belgien", "Japan", "Hongkong", "Singapur"],
            },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Unser Investmentprozess",
          items: [
            { title: "Erstes Screening", desc: "Senior-Verantwortliche prüfen jede Gelegenheit vor jeder vertieften Arbeit." },
            { title: "Vertiefte Analyse", desc: "Dokumentiertes Research zu Aktivum, Gegenpartei, Markt und Rechtsrahmen." },
            { title: "Komitee-Review", desc: "Der Investitionsausschuss bewertet die risikoadjustierten Renditen." },
            { title: "Ausführung", desc: "Rasche Umsetzung mit voller Transparenz über Kosten und Fristen." },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Senior-Direct-Lending-Programm",
          sub: "Wir begleiten Mid-Market-Unternehmen und Private-Equity-Gesellschaften, hauptsächlich Kreditnehmer mit 5–40 Mio. € EBITDA, als dauerhaften Finanzierungspartner.",
          items: [
            { title: "Flexibles Kapital", desc: "Eine minimale Haltegrösse, die Gesamtfinanzierungslösungen ermöglicht." },
            { title: "Erfahrenes Team", desc: "Tiefe Erfahrung in Strukturierung, Underwriting und Investmentmanagement." },
            { title: "Verlässlicher Partner", desc: "Unterstützung über den gesamten Investitionszyklus: organisches Wachstum, Akquisitionen, Rekapitalisierungen." },
            { title: "Position des Hauptkreditgebers", desc: "Gelegenheiten zuerst sehen, mit verstärkter Prüfung und aktiver Rolle in der Strukturierung." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Unsere Finanzierungslösungen",
          sub: "Strukturen für jede Wachstumsphase, im Open-Book-Ansatz: alle Kosten, Gebühren und Renditen sichtbar.",
          items: ["Revolvierende Kreditfazilitäten", "Unitranche / Senior Stretch", "Nachrangdarlehen", "Junior-Kapital / Mezzanine", "Krypto-Finanzierungslösungen"],
        },
      ],
    },
  },
  {
    slug: "portfolio",
    fr: {
      eyebrow: "Investissements · Portfolio",
      title: "Portfolio — une sélection de mandats accompagnés.",
      intro:
        "Présentation indicative d'investissements représentatifs de notre activité. Montants et secteurs agrégés et anonymisés pour préserver la confidentialité de nos clients.",
      chips: ["Exemples anonymisés", "Résultats indicatifs"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "Une activité mesurable, des résultats de long terme",
          items: [
            { value: "150 M €", label: "De chiffre d'affaires accompagné" },
            { value: "25", label: "Clients accompagnés" },
            { value: "18 ans", label: "D'expérience du cabinet" },
            { value: "4 % – 12 %", label: "Commission transparente" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Quatre classes d'investissement",
          sub: "Notre portefeuille se structure autour de quatre classes complémentaires, chacune servant un horizon et un profil de risque distincts.",
          items: [
            { title: "Immobilier — 38 %", desc: "Acquisition, gestion et valorisation d'actifs immobiliers en Suisse, avec cadre de protection." },
            { title: "Crédit direct senior — 27 %", desc: "Financement flexible d'entreprises du marché intermédiaire, en qualité de prêteur principal." },
            { title: "Private equity — 21 %", desc: "Partenariats avec des sociétés de capital-investissement de premier plan, sur tout le cycle de vie." },
            { title: "Financement d'entreprises — 14 %", desc: "Accompagnement de start-ups et d'entreprises en croissance, du seed à la levée de fonds." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Instruments de financement",
          sub: "Chaque mandat est structuré avec l'instrument le mieux adapté au stade, au profil de risque et aux objectifs du porteur de projet.",
          items: ["Equity investment", "Private equity", "SAFE note", "Convertible loan & note", "Prêt senior, subordonné ou unitranche"],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Exemples d'opérations, anonymisés",
          sub: "Sélection agrégée d'opérations accompagnées. Aucun nom mentionné ; montants indicatifs ne constituant pas des résultats vérifiés.",
          items: [
            { title: "Éditeur SaaS B2B — rachat majoritaire", desc: "Acquisition de la majorité du capital, reprise opérationnelle et plan de croissance à 5 ans.", tags: ["9 M €", "États-Unis", "SaaS"] },
            { title: "HealthTech — rachat total", desc: "Prise de contrôle à 100 % d'une plateforme européenne, intégration et restructuration du capital.", tags: ["6 M €", "Pays-Bas", "HealthTech"] },
            { title: "AI / SaaS — rachat minoritaire", desc: "Participation minoritaire à contrôle effectif, avec droits de gouvernance.", tags: ["4 M €", "Singapour", "IA"] },
            { title: "Société de gestion immobilière", desc: "Acquisition de la société et de son portefeuille sous-jacent, reprise des contrats de gestion.", tags: ["14 M €", "Suisse", "Immobilier"] },
            { title: "Holding hôtelière", desc: "Rachat d'une holding propriétaire de deux hôtels, structuration fiscale et plan de rénovation.", tags: ["10 M €", "Espagne", "Hôtellerie"] },
            { title: "Foncière commerciale", desc: "Acquisition d'une foncière détenant des locaux commerciaux, vérification des titres complète.", tags: ["7 M €", "Panama", "Commercial"] },
          ],
        },
        {
          type: "grid",
          theme: "light",
          title: "Cinq catégories d'actifs immobiliers",
          items: [
            { title: "Appartements", desc: "Individuels ou en portefeuille, avec gestion locative intégrée." },
            { title: "Immeubles", desc: "Résidentiels ou mixtes, approche de valorisation moyen-long terme." },
            { title: "Villas", desc: "Villas de standing sur des marchés à forte demande locative premium." },
            { title: "Hôtels & resorts", desc: "Acquisition et exploitation d'actifs hôteliers, structuration opérationnelle dédiée." },
            { title: "Locaux commerciaux", desc: "Surfaces commerciales sur des emplacements à fort potentiel." },
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Une sélection fondée sur la donnée foncière",
          items: [
            { title: "Zone géographique", desc: "Sélection selon le potentiel, le cadre juridique et la dynamique démographique." },
            { title: "Superficie habitable", desc: "Analyse de la surface utile, déterminante pour le rendement locatif." },
            { title: "Prix du m²", desc: "Évaluation comparée aux références locales et au potentiel de valorisation." },
            { title: "Aménagement & art", desc: "Mobilier haut de gamme et œuvres d'art sélectionnées pour soutenir le loyer et réduire la vacance." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Investments · Portfolio",
      title: "Portfolio — a selection of completed mandates.",
      intro:
        "An indicative presentation of investments representative of our activity. Amounts and sectors aggregated and anonymised to preserve client confidentiality.",
      chips: ["Anonymised examples", "Indicative figures"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "Measurable activity, long-term results",
          items: [
            { value: "€150M", label: "Revenue accompanied" },
            { value: "25", label: "Clients served" },
            { value: "18 yrs", label: "Firm experience" },
            { value: "4% – 12%", label: "Transparent commission" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Four investment classes",
          sub: "Our portfolio is structured around four complementary classes, each serving a distinct horizon and risk profile.",
          items: [
            { title: "Real estate — 38%", desc: "Acquisition, management and value creation across Switzerland, within a protective framework." },
            { title: "Senior direct lending — 27%", desc: "Flexible financing of mid-market companies, as lead lender." },
            { title: "Private equity — 21%", desc: "Partnerships with leading private equity firms across the full lifecycle." },
            { title: "Growth financing — 14%", desc: "Support for start-ups and growth companies, from seed to fundraising." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Financing instruments",
          sub: "Each mandate is structured with the instrument best suited to the stage, risk profile and objectives.",
          items: ["Equity investment", "Private equity", "SAFE note", "Convertible loan & note", "Senior, subordinated or unitranche loans"],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Example transactions, anonymised",
          sub: "An aggregated selection of completed operations. No names disclosed; indicative amounts, not verified results.",
          items: [
            { title: "B2B SaaS publisher — majority buyout", desc: "Majority acquisition, operational takeover and 5-year growth plan.", tags: ["€9M", "United States", "SaaS"] },
            { title: "HealthTech — full buyout", desc: "100% takeover of a European platform, integration and capital restructuring.", tags: ["€6M", "Netherlands", "HealthTech"] },
            { title: "AI / SaaS — minority stake", desc: "Minority stake with effective control rights and governance.", tags: ["€4M", "Singapore", "AI"] },
            { title: "Property management company", desc: "Acquisition of the company and its underlying portfolio, takeover of management contracts.", tags: ["€14M", "Switzerland", "Real estate"] },
            { title: "Hotel holding", desc: "Buyout of a holding owning two hotels, tax structuring and renovation plan.", tags: ["€10M", "Spain", "Hospitality"] },
            { title: "Commercial property company", desc: "Acquisition of a company holding retail premises, full title verification.", tags: ["€7M", "Panama", "Retail"] },
          ],
        },
        {
          type: "grid",
          theme: "light",
          title: "Five real estate asset categories",
          items: [
            { title: "Apartments", desc: "Individual or portfolio acquisitions, with integrated rental management." },
            { title: "Buildings", desc: "Residential or mixed-use, medium-to-long-term value creation." },
            { title: "Villas", desc: "Premium villas on markets with strong premium rental demand." },
            { title: "Hotels & resorts", desc: "Acquisition and operation of hospitality assets with dedicated structuring." },
            { title: "Commercial premises", desc: "Retail space in high-potential locations." },
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Selection grounded in land data",
          items: [
            { title: "Geographic zone", desc: "Selection by potential, legal framework and demographic dynamics." },
            { title: "Living area", desc: "Analysis of usable surface, decisive for rental yield." },
            { title: "Price per m²", desc: "Assessment against local references and value-creation potential." },
            { title: "Fit-out & art", desc: "High-end furniture and selected artworks to support rent and reduce vacancy." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Investitionen · Portfolio",
      title: "Portfolio — eine Auswahl begleiteter Mandate.",
      intro:
        "Eine indikative Präsentation repräsentativer Investitionen unserer Tätigkeit. Beträge und Sektoren aggregiert und anonymisiert, um die Vertraulichkeit unserer Kunden zu wahren.",
      chips: ["Anonymisierte Beispiele", "Indikative Ergebnisse"],
      sections: [
        {
          type: "stats",
          theme: "light",
          title: "Messbare Tätigkeit, langfristige Ergebnisse",
          items: [
            { value: "150 Mio. €", label: "Begleiteter Umsatz" },
            { value: "25", label: "Begleitete Kunden" },
            { value: "18 Jahre", label: "Erfahrung des Unternehmens" },
            { value: "4 % – 12 %", label: "Transparente Kommission" },
          ],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Vier Anlageklassen",
          sub: "Unser Portfolio ist um vier komplementäre Klassen strukturiert, jede mit eigenem Horizont und Risikoprofil.",
          items: [
            { title: "Immobilien — 38 %", desc: "Erwerb, Verwaltung und Wertschöpfung in der Schweiz, mit Schutzrahmen." },
            { title: "Senior Direct Lending — 27 %", desc: "Flexible Finanzierung von Mid-Market-Unternehmen als Hauptkreditgeber." },
            { title: "Private Equity — 21 %", desc: "Partnerschaften mit führenden Private-Equity-Gesellschaften über den gesamten Lebenszyklus." },
            { title: "Wachstumsfinanzierung — 14 %", desc: "Begleitung von Start-ups und Wachstumsunternehmen, von Seed bis Fundraising." },
          ],
        },
        {
          type: "list",
          theme: "light",
          title: "Finanzierungsinstrumente",
          sub: "Jedes Mandat wird mit dem Instrument strukturiert, das am besten zu Phase, Risikoprofil und Zielen passt.",
          items: ["Equity-Beteiligung", "Private Equity", "SAFE-Note", "Wandeldarlehen & -note", "Senior-, Nachrang- oder Unitranche-Darlehen"],
        },
        {
          type: "cards",
          theme: "dark",
          title: "Beispieltransaktionen, anonymisiert",
          sub: "Aggregierte Auswahl begleiteter Transaktionen. Keine Namen; indikative Beträge, keine geprüften Ergebnisse.",
          items: [
            { title: "B2B-SaaS-Anbieter — Mehrheitsübernahme", desc: "Mehrheitserwerb, operative Übernahme und 5-Jahres-Wachstumsplan.", tags: ["9 Mio. €", "USA", "SaaS"] },
            { title: "HealthTech — Vollübernahme", desc: "100-%-Übernahme einer europäischen Plattform, Integration und Kapitalrestrukturierung.", tags: ["6 Mio. €", "Niederlande", "HealthTech"] },
            { title: "KI / SaaS — Minderheitsbeteiligung", desc: "Minderheitsbeteiligung mit effektiven Kontroll- und Governance-Rechten.", tags: ["4 Mio. €", "Singapur", "KI"] },
            { title: "Immobilienverwaltungsgesellschaft", desc: "Erwerb der Gesellschaft und ihres zugrunde liegenden Portfolios, Übernahme der Verwaltungsverträge.", tags: ["14 Mio. €", "Schweiz", "Immobilien"] },
            { title: "Hotel-Holding", desc: "Übernahme einer Holding mit zwei Hotels, Steuerstrukturierung und Renovationsplan.", tags: ["10 Mio. €", "Spanien", "Hotellerie"] },
            { title: "Gewerbeimmobilien-Gesellschaft", desc: "Erwerb einer Gesellschaft mit Gewerbeflächen, vollständige Titelprüfung.", tags: ["7 Mio. €", "Panama", "Gewerbe"] },
          ],
        },
        {
          type: "grid",
          theme: "light",
          title: "Fünf Immobilienkategorien",
          items: [
            { title: "Wohnungen", desc: "Einzeleinheiten oder Portfolios, mit integrierter Mietverwaltung." },
            { title: "Gebäude", desc: "Wohn- oder Mischliegenschaften, mittel- bis langfristige Wertschöpfung." },
            { title: "Villen", desc: "Premium-Villen auf Märkten mit starker Premium-Mietnachfrage." },
            { title: "Hotels & Resorts", desc: "Erwerb und Betrieb von Hotelimmobilien mit dedizierter Strukturierung." },
            { title: "Gewerbeflächen", desc: "Verkaufsflächen an Standorten mit hohem Potenzial." },
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Auswahl auf Grundlage von Landdaten",
          items: [
            { title: "Geografische Zone", desc: "Auswahl nach Potenzial, Rechtsrahmen und demografischer Dynamik." },
            { title: "Wohnfläche", desc: "Analyse der Nutzfläche, entscheidend für die Mietrendite." },
            { title: "Preis pro m²", desc: "Bewertung gegen lokale Referenzen und Wertschöpfungspotenzial." },
            { title: "Ausbau & Kunst", desc: "Hochwertige Möblierung und ausgewählte Kunstwerke zur Stützung der Miete und gegen Leerstand." },
          ],
        },
      ],
    },
  },
  {
    slug: "secteurs",
    fr: {
      eyebrow: "Investissements · Secteurs",
      title: "Les secteurs où nous opérons.",
      intro:
        "Une connaissance sectorielle qui se traduit en structures de financement, choix de gouvernance et narratifs investisseurs adaptés à chaque marché.",
      chips: ["6 secteurs cœur", "Expertise transversale"],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Six secteurs cœur",
          items: [
            { title: "Immobilier & développement", desc: "Financement de projets, acquisitions et gestion d'actifs — commercial, résidentiel et mixte. Expertise SPV et finance de développement.", tags: ["Finance de développement", "Acquisition d'actifs", "Véhicules d'investissement"] },
            { title: "Services aux entreprises", desc: "Conseil, restructuration et optimisation opérationnelle, du mid-market aux groupes internationaux.", tags: ["Entrée sur marché", "Structuration", "Refonte opérationnelle"] },
            { title: "Industrie & manufacturing", desc: "Investissement stratégique et solutions de capital pour la production, incluant M&A transfrontalier.", tags: ["M&A", "Chaîne d'approvisionnement", "Financement d'expansion"] },
            { title: "Technologie & innovation", desc: "Accompagnement de sociétés tech en croissance : déploiement de capital, expansion, accès investisseurs.", tags: ["Growth capital", "Expansion internationale", "Partenariats"] },
            { title: "Énergie & infrastructure", desc: "Financement et conseil pour l'énergie durable, les utilities et les projets d'infrastructure.", tags: ["Project finance", "PPP", "Transition énergétique"] },
            { title: "Services financiers", desc: "Structuration et financement pour gérants de fonds, banques et investisseurs privés.", tags: ["Structuration de fonds", "Communication investisseurs", "Stratégie réglementaire"] },
          ],
        },
        {
          type: "list",
          theme: "dark",
          title: "Une expertise transversale de l'économie réelle",
          sub: "Au-delà des secteurs cœur, notre pratique de financement couvre l'économie élargie.",
          items: [
            "Aérospatiale & défense", "Automobile après-vente", "Produits de consommation", "Distribution", "Alimentation & boissons",
            "Énergies renouvelables", "Fabrication générale", "Emballage", "Commerce spécialisé", "Tech, médias & télécom",
            "Crypto, IA & Web3", "Santé & technologies vertes", "Immobilier",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "De la lecture sectorielle au plan d'exécution",
          items: [
            { title: "Diagnostic sectoriel", desc: "Identifier les forces commerciales, réglementaires et capitalistiques avant de recommander une structure." },
            { title: "Capital & structure", desc: "Financement, véhicules et gouvernance considérés ensemble, jamais isolément." },
            { title: "Exécution de marché", desc: "Des workstreams pensés autour des contreparties, délais, approbations et perception investisseur." },
            { title: "Préparation continue", desc: "Reporting et coordination des conseils utiles bien après la première transaction." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Investments · Sectors",
      title: "The sectors we operate in.",
      intro:
        "Sector knowledge that translates into financing structures, governance choices and investor narratives adapted to each market.",
      chips: ["6 core sectors", "Cross-sector expertise"],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Six core sectors",
          items: [
            { title: "Real estate & development", desc: "Project financing, acquisitions and asset management — commercial, residential and mixed-use. SPV and development finance expertise.", tags: ["Development finance", "Asset acquisition", "Investment vehicles"] },
            { title: "Business services", desc: "Advisory, restructuring and operational optimisation, from mid-market to international groups.", tags: ["Market entry", "Structuring", "Operating redesign"] },
            { title: "Industrial & manufacturing", desc: "Strategic investment and capital solutions for production, including cross-border M&A.", tags: ["M&A", "Supply chain", "Expansion financing"] },
            { title: "Technology & innovation", desc: "Support for growth-stage tech companies: capital deployment, expansion, investor access.", tags: ["Growth capital", "International expansion", "Partnerships"] },
            { title: "Energy & infrastructure", desc: "Financing and advisory for sustainable energy, utilities and large-scale infrastructure.", tags: ["Project finance", "PPP", "Energy transition"] },
            { title: "Financial services", desc: "Structuring and financing for fund managers, banks and private investors.", tags: ["Fund structuring", "Investor communications", "Regulatory strategy"] },
          ],
        },
        {
          type: "list",
          theme: "dark",
          title: "Cross-sector expertise in the real economy",
          sub: "Beyond the core sectors, our financing practice covers the broader economy.",
          items: [
            "Aerospace & defence", "Automotive aftermarket", "Consumer products", "Distribution", "Food & beverage",
            "Renewable energy", "General manufacturing", "Packaging", "Specialty retail", "Tech, media & telecom",
            "Crypto, AI & Web3", "Health & green tech", "Real estate",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "From sector view to execution plan",
          items: [
            { title: "Sector diagnosis", desc: "Identifying commercial, regulatory and capital forces before recommending a structure." },
            { title: "Capital & structure", desc: "Financing, vehicles and governance considered together, never in isolation." },
            { title: "Market execution", desc: "Workstreams designed around counterparties, timelines, approvals and investor perception." },
            { title: "Ongoing readiness", desc: "Reporting and advisor coordination useful well beyond the first transaction." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Investitionen · Sektoren",
      title: "Die Sektoren, in denen wir tätig sind.",
      intro:
        "Sektorwissen, das sich in Finanzierungsstrukturen, Governance-Entscheidungen und Investorennarrative übersetzt — angepasst an jeden Markt.",
      chips: ["6 Kernsektoren", "Sektorübergreifende Expertise"],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Sechs Kernsektoren",
          items: [
            { title: "Immobilien & Entwicklung", desc: "Projektfinanzierung, Akquisitionen und Asset Management — Gewerbe, Wohnen und gemischt. SPV- und Entwicklungsfinanzierungs-Expertise.", tags: ["Entwicklungsfinanzierung", "Aktivenerwerb", "Investmentvehikel"] },
            { title: "Unternehmensdienstleistungen", desc: "Beratung, Restrukturierung und operative Optimierung, vom Mid-Market bis zu internationalen Gruppen.", tags: ["Markteintritt", "Strukturierung", "Betriebliche Neugestaltung"] },
            { title: "Industrie & Fertigung", desc: "Strategische Investitionen und Kapitallösungen für die Produktion, inklusive grenzüberschreitendem M&A.", tags: ["M&A", "Lieferkette", "Expansionsfinanzierung"] },
            { title: "Technologie & Innovation", desc: "Begleitung von Tech-Wachstumsunternehmen: Kapitaleinsatz, Expansion, Investorenzugang.", tags: ["Wachstumskapital", "Internationale Expansion", "Partnerschaften"] },
            { title: "Energie & Infrastruktur", desc: "Finanzierung und Beratung für nachhaltige Energie, Versorger und Infrastrukturprojekte.", tags: ["Projektfinanzierung", "ÖPP", "Energiewende"] },
            { title: "Finanzdienstleistungen", desc: "Strukturierung und Finanzierung für Fondsmanager, Banken und Privatinvestoren.", tags: ["Fondsstrukturierung", "Investorenkommunikation", "Regulatorische Strategie"] },
          ],
        },
        {
          type: "list",
          theme: "dark",
          title: "Sektorübergreifende Expertise in der Realwirtschaft",
          sub: "Über die Kernsektoren hinaus deckt unsere Finanzierungspraxis die erweiterte Wirtschaft ab.",
          items: [
            "Luft- & Raumfahrt, Verteidigung", "Automobil-Aftermarket", "Konsumgüter", "Distribution", "Lebensmittel & Getränke",
            "Erneuerbare Energien", "Allgemeine Fertigung", "Verpackung", "Spezialitätenhandel", "Tech, Medien & Telekom",
            "Krypto, KI & Web3", "Gesundheit & grüne Technologien", "Immobilien",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Von der Sektoranalyse zum Umsetzungsplan",
          items: [
            { title: "Sektorielle Diagnose", desc: "Kommerzielle, regulatorische und kapitalbezogene Kräfte identifizieren, bevor eine Struktur empfohlen wird." },
            { title: "Kapital & Struktur", desc: "Finanzierung, Vehikel und Governance gemeinsam betrachtet, nie isoliert." },
            { title: "Marktumsetzung", desc: "Workstreams um Gegenparteien, Fristen, Genehmigungen und Investorenwahrnehmung herum gestaltet." },
            { title: "Laufende Bereitschaft", desc: "Reporting und Beraterkoordination, weit über die erste Transaktion hinaus nützlich." },
          ],
        },
      ],
    },
  },
];
